module.exports = __webpack_public_path__ + "media/nom-landing/nom-steps-2-c7884815.png";